export default "__VITE_ASSET__DZg5kO$7__"